import { ViewsAndLayoutsWrapper } from './styles';

import ViewsAndLayoutsEditItem from './ViewsAndLayoutsListItem';

const ViewsAndLayoutsEdit = ({ images }) => {
  return (
    <ViewsAndLayoutsWrapper>
      {images.map((image, index) => (
        <ViewsAndLayoutsEditItem
          key={index}
          imageId={image.imageId}
          imageIndex={image.indexNr}
        />
      ))}
    </ViewsAndLayoutsWrapper>
  );
};

export default ViewsAndLayoutsEdit;
